import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-LayersShape",
  "use": "svg-icon-LayersShape-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg-icon-LayersShape\"><g stroke=\"#000\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 1L1 7l8 6 8-6z\" /><path d=\"M1 11l8 6 8-6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol